// Haptic feedback helper — Phase 12 Plan 12-02 (UI-SPEC §Platform Contract).
//
// На результат primary-действия даём тактильный отклик: success на успех,
// error на ошибку (RESEARCH Pitfall 5). Вне Telegram (jsdom / dev) — no-op.

import { hapticFeedback } from "@telegram-apps/sdk-react";

type NotificationType = "error" | "success" | "warning";

function notify(type: NotificationType): void {
  const fn = hapticFeedback.notificationOccurred as ((t: NotificationType) => void) & {
    isAvailable?: () => boolean;
  };
  if (typeof fn === "function" && typeof fn.isAvailable === "function" && fn.isAvailable()) {
    fn(type);
  }
}

export const haptic = {
  success: (): void => notify("success"),
  error: (): void => notify("error"),
  warning: (): void => notify("warning"),
} as const;
